
/* eslint-disable */
import React, { useEffect, useState } from "react";
import * as API from "../../framework/API/api";
import { Form, FormElement } from "@progress/kendo-react-form";
import { ENTITYNAME } from "../../framework/constant/constant";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { toast } from "react-toastify";
import { useTranslation } from "../../locale/useTranslation";
import SaveRoundButton from "../../framework/forms/helpercomponents/buttons/SaveRoundButton";
import CancelRoundButton from "../../framework/forms/helpercomponents/buttons/CancelRoundButton";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import EditRoundButton from "../../framework/forms/helpercomponents/buttons/EditRoundButton";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { ConfirmDeleteAlert } from "../../ConfirmAlert";
import { useRef } from "react";
import BossDialog from "../../components/BossDialog";

const OttSubtitleForm = (props) => {
    const { ottSubtitleData = [], handleSubtitleData } = props;

    const lang = useTranslation();

    const blankDataItem = {
        kind: "subtitles",
        src: "",
        srclang: "",
        label: "",
        default: false,
        languageId: ""
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [editMode, setEditMode] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [gridData, setGridData] = useState(ottSubtitleData);
    const [languages, setLanguages] = useState([]);

    const selectedIndexRef = useRef(0);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let languagesRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
        setLanguages(languagesRes.data);
    };

    const onChange = (e) => {
        if (e.target.name === 'default') {
            setDataItem({ ...dataItem, default: !dataItem.default });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const onLangChange = (e) => {
        const selectedLang = e.value;
        setDataItem({
            ...dataItem,
            srclang: selectedLang?.ISOCode?.split("_")[0],
            label: selectedLang?.Description,
            languageId: selectedLang?._id,
            kind: "subtitles"
        });
    };

    const isValid = () => {

        if (!dataItem.src || dataItem.src == undefined) {
            toast.error(`${lang.please_select_url_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        if (!dataItem.languageId || dataItem.languageId == undefined) {
            toast.error(`${lang.please_select_language_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        return true;
    };

    const addSubtitle = () => {
        if (!isValid()) return;
        const newData = [...gridData, { ...dataItem, kind: "subtitles" }];
        setGridData(newData);
        handleSubtitleData(newData);
        clearData();
    };

    const editSubtitle = () => {
        if (!isValid()) return;
        const newData = [...gridData];
        newData[selectedIndexRef.current] = { ...dataItem, kind: "subtitles" };
        setGridData(newData);
        handleSubtitleData(newData);
        clearData();
    };

    const removeSubtitle = (index) => {
        const newData = [...gridData];
        newData.splice(index, 1);
        setGridData(newData);
        handleSubtitleData(newData);
        toast.success(
            `${lang.delete_successfully_grid_data_success_toast_message}`,
            {
                position: toast.POSITION.TOP_RIGHT,
            }
        );
    };

    const editFormGrid = (data) => {
        selectedIndexRef.current = data.dataIndex;
        setDataItem({ ...data.dataItem, kind: "subtitles" });
        setToggle(true);
        setEditMode(true);
    };

    const clearData = () => {
        setDataItem(blankDataItem);
        setEditMode(false);
        setToggle(false);
    };

    const MyCommandCell = (props) => (
        <div style={{ display: "flex", marginTop: "4px" }}>
            <EditRoundButton onClick={() => editFormGrid(props)} />
            <DeleteRoundButton
                onClick={() =>
                    ConfirmDeleteAlert(
                        () => removeSubtitle(props.dataIndex),
                        () => { }
                    )
                }
            />
        </div>
    );

    return (
        <div
            style={{
                boxShadow: "0px 0px 10px 1px lightgrey",
                backgroundColor: "#EEEEEE",
                borderRadius: "10px",
                padding: "10px 20px 20px 20px"
            }}
        >
            <div className="row">
                <div className="col-12">
                    <AddRoundButton onClick={() => setToggle(true)} />
                    <Grid data={gridData} style={{ height: "20vh" }} className="mt-2">
                        <GridColumn cell={MyCommandCell} width={"73px"} locked />
                        <GridColumn field="src" title={lang.url_column} />
                        <GridColumn field="srclang" title={lang.language_code_column} />
                        <GridColumn field="label" title={lang.label} />
                    </Grid>
                </div>

                {toggle && (
                    <BossDialog
                        title={editMode ? "Edit Subtitle" : "Add Subtitle"}
                        onClose={clearData}
                        width={700}
                        height={280}
                    >
                        <div className="row">
                            <div className="col-12">
                                <div className="row mt-2">
                                    <div className="marlr">
                                        {!editMode && (
                                            <AddRoundButton onClick={addSubtitle} />
                                        )}
                                        {editMode && (
                                            <SaveRoundButton onClick={editSubtitle} />
                                        )}
                                        <CancelRoundButton onClick={clearData} />
                                    </div>
                                </div>
                                <div className="mt-1" style={{ border: "groove 1px" }}>
                                    <div className="row" style={{ margin: "5px" }}>
                                        <div className="col-12 mt-2">
                                            <div className="row">
                                                <div className="col-6">
                                                    <label>{lang.language_label} *</label>
                                                    <DropDownList
                                                        style={{ backgroundColor: "white" }}
                                                        data={languages}
                                                        textField="Description"
                                                        dataItemKey="_id"
                                                        value={languages.find(
                                                            (x) => x._id === dataItem.languageId
                                                        ) ?? null
                                                        }
                                                        onChange={onLangChange}
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <label htmlFor="src">{lang.url_label} *</label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        name="src"
                                                        value={dataItem.src}
                                                        onChange={onChange}
                                                    />
                                                </div>
                                                <div className="col-6 mt-2">
                                                    <input
                                                        type="checkbox"
                                                        name="default"
                                                        checked={dataItem.default}
                                                        onChange={onChange}
                                                    />
                                                    <label className="ml-2 mt-1">{lang.default_label}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BossDialog>
                )}
            </div>
        </div>
    );
}


export default OttSubtitleForm;
